export enum EmptyStateOverlayVisualization {
  Text,
  TextAndImage,
}
